import { Contract2Plausibilitaet } from '../../mdqx-graphql-types';

export class Contract2PlausibilitaetEntity {
    public static readonly GqlFields = 'contractId id plausibilitaetId';

    public ContractId: number;
    public Id: number;
    public PlausibilitaetId: number;

    constructor(contract2PlausibilitaetType: Contract2Plausibilitaet | null) {
        if (
            contract2PlausibilitaetType &&
            contract2PlausibilitaetType.contractId != null &&
            contract2PlausibilitaetType.id != null &&
            contract2PlausibilitaetType.plausibilitaetId != null
        ) {
            this.ContractId = contract2PlausibilitaetType.contractId;
            this.Id = contract2PlausibilitaetType.id;
            this.PlausibilitaetId = contract2PlausibilitaetType.plausibilitaetId;
        } else {
            console.error(
                'received broken Contract2PlausibilitaetType',
                contract2PlausibilitaetType,
            );
            throw Error();
        }
    }
}
